import { lazy } from "react";
import "./App.scss";
import { Outlet, Route, Routes } from "react-router-dom";
import NotFound from "screens/NotFound";
import Logout from "screens/Logout";
import RequireAuth from "common/core/RequireAuth";
import Header from "components/Header";
import Navbar from "components/Navbar";
import NoAccess from "screens/NoAccess";
import Footer from "components/Footer";
import OfflineIndicator from "common/ui/OfflineIndicator";
import Toaster from "common/ui/Toaster";
import AuditLogs from "screens/AuditLogs";

const Dashboard = lazy(
  () =>
    import(
      /*  webpackPreload: true  */
      "screens/Dashboard"
    )
);
const Settings = lazy(
  () =>
    import(
      /* webpackPrefetch: true */
      "screens/Settings"
    )
);
const Machines = lazy(
  () =>
    import(
      /* webpackPrefetch: true */
      "screens/Machines"
    )
);
const IndividualMachine = lazy(
  () =>
    import(
      /* webpackPrefetch: true */
      "screens/IndividualMachine"
    )
);
const Runs = lazy(
  () =>
    import(
      /* webpackPrefetch: true */
      "screens/Runs"
    )
);
const IndividualRun = lazy(
  () =>
    import(
      /*  webpackPreload: true  */
      "screens/IndividualRun"
    )
);
const Softwares = lazy(
  () =>
    import(
      /*  webpackPreload: true  */
      "screens/Softwares"
    )
);

function App() {
  return (
    <>
      <Header />
      <main className="main">
        <Routes>
          <Route element={<RequireAuth component={<Outlet />} />}>
            <Route element={<Navbar children={<Outlet />} />}>
              <Route path="" element={<Dashboard />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/runs" element={<Runs />} />
              <Route path="/runs/:runId" element={<IndividualRun />} />
              <Route path="/machines" element={<Machines />} />
              <Route
                path="/machines/:machineId"
                element={<IndividualMachine />}
              />
              <Route path="/softwares" element={<Softwares />} />
              <Route path="/settings/user-management" element={<Settings />} />
              <Route path="/settings/audit-logs" element={<AuditLogs />} />
            </Route>
          </Route>
          <Route path="/logout" element={<Logout />} />
          <Route path="/no-access" element={<NoAccess />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <OfflineIndicator />
        <Toaster />
      </main>
      <Footer />
    </>
  );
}

export default App;
